import { render, staticRenderFns } from "./InvoicesPreview.vue?vue&type=template&id=3c3f127b&scoped=true&"
import script from "./InvoicesPreview.vue?vue&type=script&lang=js&"
export * from "./InvoicesPreview.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesPreview.vue?vue&type=style&index=0&id=3c3f127b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3f127b",
  null
  
)

export default component.exports